import type { Page } from '../../types';

const minStandardCorporate: Page[] = [
  {
    pageType: 'question',
    title: 'Minimum Standards',
    name: 'minimum-standards',
    hidePageTitle: true,
    description:
      'A conversation must take place at the start of the year between you and your line manager to agree how these standards will be demonstrated in a way that is relevant to your role. You should agree how you will determine whether you have ‘met’ these <a href="https://intranet.cabinetoffice.gov.uk/documents/2180/3717_SCS_Minimum_Standards_AW_3nspT0U.pdf" target="_blank" rel="noopener noreferrer">minimum standards</a>.<br><br>Line Managers will make judgements on whether standards have been met as part of their validation.<br><br>Please complete the box below on how you have met each of the Minimum Standards. Please refer to evidence captured throughout the performance year<br><br>',
    questions: [
      {
        questionType: 'textarea',
        textRows: 20,
        title: 'Corporate',
        name: 'minimum-standard-corporate',
        detailsHeading: 'More information',
        detailsContent: `The minimum Corporate standards require all SCS to:<br><ul>
  <li>Lead the Civil Service by contributing to its collective running, performance, culture and reputation, beyond their business unit and immediate responsibilities.</li>
  <li>Actively deliver organisation-wide and/or gross government initiatives by embedding them into their work and enabling teams to understand and contribute to these.</li>
  <li>Activity that goes above and beyond the day to day role. Impact should be seen at departmental level and reach beyond the boundaries of your business unit.</li>
</ul>`,
        hint: `How will this be demonstrated in my role?  
  • There is an expectation that each SCS member will undertake an activity that goes above and beyond the day to day role.  
  • In the instances where the contribution sits within the Business Unit. It is important that the impact of the contribution reaches wider than the DG group and extends across the Cabinet Office or across the Civil Service in order to be placed in Exceeding or High Performing.`,
        wordCount: 250,
        rules: {
          required: true,
        },
      },
      {
        questionType: 'select',
        title: 'What was the reach of your actions during this reporting period?',
        name: 'person-details-reach',
        options: [
          'Within Business Unit',
          'Cross‑Directorate (within Cabinet Office)',
          'Cross‑Department (across government departments)',
          'Civil Service‑wide',
        ],
        rules: {
          required: true,
        },
      },
    ],
  },
];

export default minStandardCorporate;
